import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type AdminPersistence } from '../../../../types/persistence/admin-persistence'

type MutationArgs = {
  id: number
  data: AdminPersistence
}

const updateAdmin = async (id: number, data: AdminPersistence) => {
  const response = await api.put(`/admins/${id}`, data)
  return response.data
}

export const useEditAdminMutation = () => {
  return useMutation(
    'edit-admin',
    ({ id, data }: MutationArgs) => updateAdmin(id, data)
  )
}
